import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { NgSelectModule } from '@ng-select/ng-select';

import { GlobalErrorHandler } from '../../../../src/app/global_error_handler/error-handler';

import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { ToastrModule } from 'ngx-toastr';

import { JwtInterceptorService } from '../../../../src/app/shared/services/jwtInterceptor.service';
import { ErrorInterceptorService } from '../../../../src/app/shared/services/errorInterceptor.service';
import { MatStepperModule } from '@angular/material/stepper';


import { AppComponent } from './app.component';

// Import containers
import { LayoutComponent } from '../app/modules/layout/layout.component';
import { GarageVisitComponent } from '../app/modules/garage-visit/garage-visit.component';
import { GarageSelectComponent } from '../app/modules/garage-select/garage-select.component';
import { GarageVisitConfirmationComponent } from '../app/modules/garage-visit-confirmation/garage-visit-confirmation.component';


import { SharedModule } from '../../../../src/app/shared/shared.module';
import { P404Component } from '../../../../src/app/shared/pages/error/404.component';
import { P500Component } from '../../../../src/app/shared/pages/error/500.component';
import { BannerService } from '../../../../src/app/shared/services/banner.service';
import { CommonModule } from '@angular/common';


import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
} from '../../../../src/app/shared/components/layout/coreui';

// Import routing module
import { AppRoutingModule } from './app-routing.module';

// NGXS - states
import { UserPanelState } from '../../../../src/app/shared/components/layout/minidashboard/user-panel/user-panel.state';
import { LogState } from '../../../../src/app/shared/services/log/log.state';

import { RemindPasswordState } from '../../../../src/app/shared/pages/remind-password/remind-password.state';
import { SpecificationState } from '../../../../src/app/services/specification/specification.state';
import { CarState } from '../../../../src/app/services/car/car.state';
import { DepositeState } from '../../../../src/app/services/deposite/deposite.state';
import { GarageState } from '../../../../src/app/services/garage/garage.state';
import { CustomerState } from '../../../../src/app/services/customer/customer.state';
import { ArticleState } from '../../../../src/app/services/article/article.state';
import { TyreState } from '../../../../src/app/services/tyre/tyre.state';
import { AlertState } from '../../../../src/app/services/alert/alert.state';
import { ServiceCompaniesState } from '../../../../src/app/services/service-companies/service-companies.state';
import { UserState } from '../../../../src/app/services/user/user.state';

import { OrderState } from '../../../../src/app/services/order/order.state';
import { RelocationOrderState } from '../../../../src/app/services/relocation-order/relocation-order.state';
import { TyreReturnOrderState } from '../../../../src/app/services/tyre-return-order/tyre-return-order.state';
import { TyreReregistrationOrderState } from '../../../../src/app/services/tyre-reregistration-order/tyre-reregistration-order.state';
import { TyreRepairOrderState } from '../../../../src/app/services/tyre-repair-order/tyre-repair-order.state';
import { UtilisationOrderState } from '../../../../src/app/services/utilisation-order/utilisation-order.state';
import { TyreChangeOrderState } from '../../../../src/app/services/tyre-change-order/tyre-change-order.state';
import { TyreTakeoverOrderState } from '../../../../src/app/services/tyre-takeover-order/tyre-takeover-order.state';
import { TyreOrderState } from '../../../../src/app/services/tyre-order/tyre-order.state';
import { GarageInvoiceState } from '../../../../src/app/services/garage-invoice/garage-invoice.state';
import { UtilizationState } from '../../../../src/app/services/utilization/utilization.state';
import { TyreOfferState } from '../../../../src/app/services/tyre-offer/tyre-offer.state';
import { TyreOfferParametersState } from '../../../../src/app/services/tyre-offer-parameters/tyre-offer-parameters.state';
import { TyreStateState } from '../../../../src/app/services/tyre-state/tyre-state.state';
import { SaleArticleState } from '../../../../src/app/services/sale-article/sale-article.state';
import { SaleServiceState } from '../../../../src/app/services/sale-service/sale-service.state';
import { MapState } from '../../../../src/app/services/map/map.state';
import { PricelistState } from '../../../../src/app/services/pricelist/pricelist.state';
import { PricelistDetailState } from '../../../../src/app/services/pricelist-detail/pricelist-detail.state';
import { PricelistCurrentState } from '../../../../src/app/services/pricelist-current/pricelist-current.state';
import { CatalogueState } from '../../../../src/app/services/catalogue/catalogue.state';
import { BrandManagamentState } from '../../../../src/app/services/brand-managament/brand-managament.state';
import { ServiceState } from '../../../../src/app/services/services/services.state';
import { CostEstimationState } from '../../../../src/app/services/cost-estimation/cost-estimation.state';
import { InventoryState } from '../../../../src/app/services/inventory/inventory.state';
import { CourierState } from '../../../../src/app/services/couriers/courier.state';
import { RoleState } from '../../../../src/app/services/roles/role.state';
import { ClientRoleState } from '../../../../src/app/services/client-roles/client-role.state';
import { PermissionState } from '../../../../src/app/services/permissions/permissions.state';
import { DashboardState } from '../../../../src/app/services/dashboard/dashboard.state';
import { DocumentState } from '../../../../src/app/services/document/document.state';
import { UserTypesState } from '../../../../src/app/services/user-types/user-types.state';
import { DictionaryState } from '../../../../src/app/services/dictionary/dictionary.state';
import { ContractState } from '../../../../src/app/services/contract/contract.state';
import { AldAnonymousState } from '../../../../src/app/services/ald-anonymous/ald-anonymous.state';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts';
import { MenubarModule } from 'primeng/menubar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ScrollPanelModule } from 'primeng/scrollpanel';

import { environment } from '../environments/environment';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { GarageVisitsState } from '../../../../src/app/services/garage-visits/garage-visits.state';

import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { CalendarModule } from 'primeng/calendar';
import { GoogleMapsModule } from '@angular/google-maps';
import { GOOGLE_MAPS_API_KEY } from '../../../../src/app/services/map/google-maps-loader.service';


@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ToastrModule.forRoot(), // ToastrModule added
    ChartsModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule,
    MenubarModule,
    RadioButtonModule,
    ScrollPanelModule,
    SharedModule,
    DialogModule,
    ConfirmDialogModule,
    CalendarModule,
    NgSelectModule,
    AutoCompleteModule,
    MatStepperModule,
    NgxsModule.forRoot([
      UserPanelState,
      LogState,
      AlertState,
      RemindPasswordState,
      SpecificationState,
      CarState,
      CourierState,
      RoleState,
      DashboardState,
      ClientRoleState,
      DepositeState,
      GarageState,
      CustomerState,
      PermissionState,
      TyreState,
      ServiceCompaniesState,
      UserState,
      OrderState,
      RelocationOrderState,
      TyreReturnOrderState,
      TyreReregistrationOrderState,
      TyreRepairOrderState,
      UtilisationOrderState,
      TyreOrderState,
      TyreChangeOrderState,
      TyreTakeoverOrderState,
      GarageInvoiceState,
      UtilizationState,
      ArticleState,
      TyreOfferState,
      TyreOfferParametersState,
      TyreStateState,
      SaleArticleState,
      SaleServiceState,
      MapState,
      PricelistState,
      PricelistDetailState,
      PricelistCurrentState,
      CatalogueState,
      BrandManagamentState,
      ServiceState,
      CostEstimationState,
      UserState,
      InventoryState,
      DictionaryState,
      UserTypesState,
      ContractState,
      DocumentState,
      GarageVisitsState,
      AldAnonymousState
    ]),
    GoogleMapsModule,
  ],
  declarations: [
    AppComponent,
    LayoutComponent,
    P404Component,
    P500Component,
    GarageVisitComponent,
    GarageSelectComponent,
    GarageVisitConfirmationComponent
  ],
  providers: [
    // Klucz przekazywany wczesniej do AgmCoreModule.forRoot().
    { provide: GOOGLE_MAPS_API_KEY, useValue: 'AIzaSyCr_uiy95HlE4I4NzYAYm_3oo8y6KSN860' },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptorService, multi: true },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    BannerService

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
